// removed by extract-text-webpack-plugin
module.exports = {"text":"StudentNote__text___1Q_7R"};